import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card-header d-flex flex-row justify-content-between" }
const _hoisted_2 = { class: "btn-toolbar" }
const _hoisted_3 = { class: "form-check form-switch" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "list-group small mb-3" }
const _hoisted_6 = ["onClick", "disabled"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "list-group small" }
const _hoisted_10 = ["onClick", "disabled"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "card-footer" }
const _hoisted_14 = { class: "d-flex justify-content-center" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "fas fa-spinner fa-spin ms-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkout_modal = _resolveComponent("checkout-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps({ class: "card" }, _ctx.$attrs), [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("span", null, [
          _createElementVNode("i", { class: "fas fa-file-invoice-dollar fa-fw me-1" }),
          _createTextVNode("Crear Ficha de Pago ")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input secondary",
              type: "checkbox",
              role: "switch",
              id: "share-email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.update) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.update]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[6] || (_cache[6] = _createElementVNode("h6", { class: "fw-bold small" }, "Subscripciones", -1)),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subs, (sub) => {
            return (_openBlock(), _createElementBlock("button", {
              key: sub[0],
              class: _normalizeClass(["list-group-item list-group-item-action d-flex justify-content-between", {
              'bg-secondary text-white':
                _ctx.selectedSubscription === sub[1] && _ctx.update && !_ctx.activating,
              disabled:
                !_ctx.canCreateQuote(sub[1].subscriptionId) || !_ctx.update || _ctx.activating,
              'bg-gray-200': !_ctx.canCreateQuote(sub[1].subscriptionId),
            }]),
              onClick: ($event: any) => (_ctx.selectSubscription(sub[1])),
              disabled: !_ctx.canCreateQuote(sub[1].subscriptionId)
            }, [
              _createElementVNode("span", null, _toDisplayString(sub[1].displayName), 1),
              (_ctx.canCreateQuote(sub[1].subscriptionId))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("span", null, "G$ " + _toDisplayString(sub[1].cost), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[4] || (_cache[4] = [
                    _createElementVNode("i", { class: "fas fa-lock" }, null, -1)
                  ]))]))
            ], 10, _hoisted_6))
          }), 128))
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("h6", { class: "fw-bold small" }, "Promociones", -1)),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promotions, (promotion) => {
            return (_openBlock(), _createElementBlock("button", {
              key: promotion._id,
              class: _normalizeClass(["list-group-item list-group-item-action d-flex justify-content-between", {
              'bg-secondary text-white':
                _ctx.selectedSubscription === promotion && _ctx.update && !_ctx.activating,
              disabled:
                !_ctx.canCreateQuote(promotion.subscriptionId) ||
                !_ctx.update ||
                _ctx.activating,
            }]),
              onClick: ($event: any) => (_ctx.selectSubscription(promotion)),
              disabled: !_ctx.canCreateQuote(promotion.subscriptionId)
            }, [
              _createElementVNode("span", null, _toDisplayString(promotion.displayName), 1),
              (_ctx.canCreateQuote(promotion.subscriptionId))
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("span", null, "G$ " + _toDisplayString(promotion.cost), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[5] || (_cache[5] = [
                    _createElementVNode("i", { class: "fas fa-lock" }, null, -1)
                  ]))]))
            ], 10, _hoisted_10))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            class: "btn btn-outline-warning col-6",
            disabled: !_ctx.selectedSubscription || !_ctx.update || _ctx.activating,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createQuote(false)))
          }, [
            _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fas fa-qrcode fa-fw me-1" }, null, -1)),
            _cache[9] || (_cache[9] = _createTextVNode("Crear ", -1)),
            (_ctx.activating)
              ? (_openBlock(), _createElementBlock("i", _hoisted_16))
              : _createCommentVNode("", true)
          ], 8, _hoisted_15)
        ])
      ])
    ], 16),
    _createVNode(_component_checkout_modal, {
      quote: _ctx.quote,
      onClearQuote: _ctx.clearQuote,
      onRenewQuote: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createQuote(true)))
    }, null, 8, ["quote", "onClearQuote"])
  ], 64))
}